// Code for CV download

import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './resume.pdf';

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>About</span>
        <span>Me</span>
        <span>
        Motivated and efficient Full-stack web developer with a history of education in BBA 
        <br/>
        and an interest in coding. Working with MERN stack and programming languages like JavaScript 
        <br/>
        catalyzed my curiosity for web development. I have worked in collaborative environments 
        <br/>
        demonstrating my coding and interpersonal skills to meet deadlines. 
        <br/>
        Looking forward for some interesting and challenging opportunities.
         
        </span>
       
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
    
      <div className="cards">
        {/* first card */}
        
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Full Stack Web Development"}
            detail={"Self Learned"}
            time={"November 2021 - June 2022"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"B.Tech(Computr Science)"}
            detail={"G.L Bajaj institute of management and technology"}
            time={"April 2017 - July 2021"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Post Graduation"}
            detail={
              "P.G.D.M(IT,Marketing)"
            }
            time={"+91-7007324200"}
            location = {"Varanasi. Uttar Pradesh "}
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
